// extracted by mini-css-extract-plugin
export default {"root":"Trialinfo__root--1UWNp","text":"Trialinfo__text--9dqoo","buttonText":"Trialinfo__buttonText--YejXt"};